import React from 'react';

import { PolymarketDisclaimer } from '@/components/PolymarketDisclaimer';
import { Box } from '@/components/lib/components';

import { SinglesList } from '../SinglesList';

const ListFooterComponent = () => (
    <Box mt="s16">
        <PolymarketDisclaimer />
    </Box>
);

export const PredictionsTabScreen = () => <SinglesList ListFooterComponent={ListFooterComponent} />;
